import Cookies from 'cookies-js';

import ngettext from 'js-utils/ngettext';

import {NOTIFICATION_COOKIE} from '../constants';

export const getUpcomingEventCopy = (numUpcomingEvents) => ngettext(
    'upcoming event',
    'upcoming events',
    numUpcomingEvents
);

const hasFollowOrganizerCookie = () => {
    const notificationCookieValue = Cookies.get(NOTIFICATION_COOKIE);

    return notificationCookieValue !== undefined;
};

export const shouldShowGDPRModal = () => !hasFollowOrganizerCookie();
